import API from 'API/index'
import {enqueueSnackbar as enqueueSnackbarAction} from 'store/actions/notifier'
import * as typeNotifier from 'shared/typeNotifications'
import * as informationMessages from 'constants/infoMessages'

// --- Shift Status ---
export const START_LOAD_SHIFT_STATUS = 'START_LOAD_SHIFT_STATUS'
export const SUCCESS_LOAD_SHIFT_STATUS = 'SUCCESS_LOAD_SHIFT_STATUS'
export const ERROR_LOAD_SHIFT_STATUS = 'ERROR_LOAD_SHIFT_STATUS'

export const fetchShiftStatus = (plantId, t) => dispatch => {
  dispatch({type: START_LOAD_SHIFT_STATUS})
  API.getShiftStatus(plantId)
    .then(({data}) => {
      dispatch({type: SUCCESS_LOAD_SHIFT_STATUS, data})
    })
    .catch(() => {
      dispatch({type: ERROR_LOAD_SHIFT_STATUS})
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.DATA_LOADING_ERROR}`),
          options: {
            variant: typeNotifier.ERROR,
          },
        }),
      )
    })
}

// --- Shift Transfer ---
export const START_LOAD_SHIFT_TRANSFER = 'START_LOAD_SHIFT_TRANSFER'
export const SUCCESS_LOAD_SHIFT_TRANSFER = 'SUCCESS_LOAD_SHIFT_TRANSFER'
export const ERROR_LOAD_SHIFT_TRANSFER = 'ERROR_LOAD_SHIFT_TRANSFER'
export const RESET_IS_LOADED_SHIFT_TRANSFER = 'RESET_IS_LOADED_SHIFT_TRANSFER'

export const START_SEND_SHIFT_TRANSFER = 'START_SEND_SHIFT_TRANSFER'
export const SUCCESS_SEND_SHIFT_TRANSFER = 'SUCCESS_SEND_SHIFT_TRANSFER'
export const ERROR_SEND_SHIFT_TRANSFER = 'ERROR_SEND_SHIFT_TRANSFER'
export const SET_ERROR_SEND_SHIFT_TRANSFER_CONFLICT_DEVALUATION =
  'SET_ERROR_SEND_SHIFT_TRANSFER_CONFLICT_DEVALUATION'
export const RESET_ERROR_SEND_SHIFT_TRANSFER_CONFLICT_DEVALUATION =
  'RESET_ERROR_SEND_SHIFT_TRANSFER_CONFLICT_DEVALUATION'

export const RESET_GET_AND_SEND_SHIFT_TRANSFER = 'RESET_GET_AND_SEND_SHIFT_TRANSFER'

export const fetchShiftTransfer = (plantId, t) => dispatch => {
  dispatch({type: START_LOAD_SHIFT_TRANSFER})
  API.getShiftTransfer(plantId)
    .then(({data}) => {
      dispatch({type: SUCCESS_LOAD_SHIFT_TRANSFER, data})
    })
    .catch(() => {
      dispatch({type: ERROR_LOAD_SHIFT_TRANSFER})
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.SHIFT_TRANSFER_ERROR}`),
          options: {
            variant: typeNotifier.ERROR,
          },
        }),
      )
    })
}

export const sendTransferShift = (dto, t) => dispatch => {
  dispatch({type: START_SEND_SHIFT_TRANSFER})
  API.sendShiftTransfer(dto)
    .then(({data}) => {
      dispatch({type: SUCCESS_SEND_SHIFT_TRANSFER, data})
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.SEND_SHIFT_TRANSFER_SUCCESS}`),
          options: {
            variant: typeNotifier.SUCCESS,
          },
        }),
      )
    })
    .catch(error => {
      dispatch({type: ERROR_SEND_SHIFT_TRANSFER})
      const is409 = error?.response?.status === 409

      if (is409) {
        dispatch({type: SET_ERROR_SEND_SHIFT_TRANSFER_CONFLICT_DEVALUATION})
      } else {
        dispatch(
          enqueueSnackbarAction({
            message: t(`infoMessages:${informationMessages.SEND_SHIFT_TRANSFER_ERROR}`),
            options: {
              variant: typeNotifier.ERROR,
            },
          }),
        )
      }
    })
}

// --- Shift Accepting ---
export const START_LOAD_SHIFT_ACCEPTING = 'START_LOAD_SHIFT_ACCEPTING'
export const SUCCESS_LOAD_SHIFT_ACCEPTING = 'SUCCESS_LOAD_SHIFT_ACCEPTING'
export const ERROR_LOAD_SHIFT_ACCEPTING = 'ERROR_LOAD_SHIFT_ACCEPTING'
export const RESET_SHIFT_ACCEPTING = 'RESET_SHIFT_ACCEPTING'

export const START_SEND_SHIFT_ACCEPTING = 'START_SEND_SHIFT_ACCEPTING'
export const SUCCESS_SEND_SHIFT_ACCEPTING = 'SUCCESS_SEND_SHIFT_ACCEPTING'
export const ERROR_SEND_SHIFT_ACCEPTING = 'ERROR_SEND_SHIFT_ACCEPTING'

export const fetchShiftAcceptance = t => dispatch => {
  dispatch({type: START_LOAD_SHIFT_ACCEPTING})
  API.getShiftAcceptance()
    .then(({data}) => {
      dispatch({type: SUCCESS_LOAD_SHIFT_ACCEPTING, data})
    })
    .catch(() => {
      dispatch({type: ERROR_LOAD_SHIFT_ACCEPTING})
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.SHIFT_ACCEPTANCE_ERROR}`),
          options: {variant: typeNotifier.ERROR},
        }),
      )
    })
}

export const sendAcceptShift = t => dispatch => {
  dispatch({type: START_SEND_SHIFT_ACCEPTING})
  API.sendShiftAcceptance()
    .then(() => {
      dispatch({type: SUCCESS_SEND_SHIFT_ACCEPTING})
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.ACCEPT_SHIFT_SUCCESS}`),
          options: {variant: typeNotifier.SUCCESS},
        }),
      )
    })
    .catch(() => {
      dispatch({type: ERROR_SEND_SHIFT_ACCEPTING})
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.ACCEPT_SHIFT_ERROR}`),
          options: {variant: typeNotifier.ERROR},
        }),
      )
    })
}
